import React from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../../widgets/tables/Table";
import WaitDialog from "../../../widgets/WaitDialog";
import SelectPdfDatesWidget from "../../../widgets/SelectPdfDatesWidget";

import SendMailWidget from "../../../widgets/SendMailWidget";
import SendNotificationWidget from "../../../widgets/SendNotificationWidget";
import GetCorsi from "../../../services/getCorsi";
import getStudenti from "../../../services/getStudentiForBilling";
import addNotification from "../../../services/addNotification";
import sendMail from "../../../services/sendMail";
import getSetting from "../../../services/getSetting";
import saveFile from "../../../services/saveFile";
import Utils from "../../../utils/utils";
import moment from "moment";
import "moment/locale/it";
import CostoCorsoDialog from "../../../widgets/CostoCorsoDialog";

export default class Corsi extends React.Component {
  constructor(props) {
    super(props);

    // Configura moment.js per l'italiano
    moment.locale("it");

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];

    this.selectRef = React.createRef();

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      selectPdfDatesVisible: false,
      mailCompaniesList: [],
      costoCorso: null,
    };

    this.grid = 2;

    this.pdfElements = [];

    this.corsi = [];
    this.pageTitle = "Corsi";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({ list: [] });
    cookies.set("checksList", strJson, { path: "/" });
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.state = {
      costoCorso: null,
      nomeCorsoCosto: null,
    };
  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.corsi = await GetCorsi(username, token);
    this.studenti = await getStudenti(username, token);

    this.corsi.forEach((corso, index) => {
      var dateStart = corso.dateStart;
      var dateEnd = corso.dateEnd;

      dateStart = moment(dateStart, "yyyy-MM-DD").format("DD/MM/YYYY");
      dateEnd = moment(dateEnd, "yyyy-MM-DD").format("DD/MM/YYYY");
      corso.dateStart = dateStart;
      corso.dateEnd = dateEnd;
      this.corsi[index] = corso;
    });

    this.setState({});
  }

  async componentDidMount() {
    await this.reload();
  }

  render() {
    const cookies = new Cookies();

    var headCells = [
      { id: "name", numeric: false, disablePadding: true, label: "Nome" },
      {
        id: "dateStart",
        numeric: true,
        disablePadding: false,
        label: "Data inizio",
      },
      {
        id: "dateEnd",
        numeric: true,
        disablePadding: false,
        label: "Data fine",
      },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    this.searchCols = ["name"];

    return (
      <div id={Math.random()}>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle title="Corsi" />

          <Table
            headCells={headCells}
            searchCols={this.searchCols}
            rows={this.corsi}
            mail={false}
            phone={false}
            calendar={false}
            pdf={false}
            invoices={true}
            onEventClick={(row) => {
              cookies.set("currentCourse", row, { path: "/" });
              window.location.href = "/#/billing/editCorso";
            }}
            onInvoicesPressed={(row) => {
              const corso = this.corsi.find((s) => s.id === row);
              if (!corso) return;
              this.setState({ costoCorso: row, nomeCorsoCosto: corso.name });
            }}
          />

          {this.elementPdf ? this.elementPdf : null}

          <SendMailWidget
            ref={this.sendMailRef}
            show={this.state.sendMailVisible}
            onClose={() => this.setState({ sendMailVisible: false })}
            onSend={async (subject, body, file) => {
              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              this.mail = await getSetting(
                username,
                token,
                "sendingMailAddress"
              );
              this.mailPassword = await getSetting(
                username,
                token,
                "sendingMailPassword"
              );

              var corso = this.corsi.find(
                (s) => s.id == this.state.sendMailUserId
              );
              this.studentiCorso = this.studenti.filter((s) =>
                s.corsi
                  .split(";")
                  .filter(Boolean)
                  .includes(corso.id.toString())
              );

              if (file != undefined) {
                this.filePath = await saveFile(
                  username,
                  token,
                  file.name,
                  file.base64
                );
              }

              var incorrectMails = [];

              var indirizzi = "";
              var nomi = "";

              this.studentiCorso.forEach(async (studente) => {
                studente.mail = studente.mail.trim();
                studente.mail2 = studente.mail2.trim();

                if (studente.mail != "") {
                  if (Utils.validateEmail(studente.mail) == false)
                    incorrectMails.push(studente.mail);
                  else {
                    indirizzi += studente.mail + "---";
                    nomi += studente.nome + " " + studente.cognome + "---";
                  }
                }
                if (studente.mail2 != "") {
                  if (Utils.validateEmail(studente.mail2) == false)
                    incorrectMails.push(studente.mail2);
                  else {
                    indirizzi += studente.mail2 + "---";
                    nomi += studente.nome + " " + studente.cognome + "---";
                  }
                }
              });

              if (incorrectMails.length > 0) {
                var msg =
                  "I seguenti indirizzo mail non sono corretti e sarebbero ignorati:\n";
                incorrectMails.forEach((mail) => (msg += mail + "\n"));
                msg += "Inviare comunque la mail?";

                if (window.confirm(msg) == false) return;
              }

              indirizzi = indirizzi.substring(0, indirizzi.length - 3);
              nomi = indirizzi.substring(0, indirizzi.length - 3);
              await sendMail(
                username,
                token,
                this.mail,
                "Accademia Nazionale del Cinema",
                this.mailPassword,
                indirizzi,
                nomi,
                file ? this.filePath.name : "",
                subject,
                body
              );

              this.setState({ waitDialogVisible: false });
              this.setState({ sendMailVisible: false });
            }}
          />

          <SendNotificationWidget
            ref={this.sendNotificationRef}
            show={this.state.sendNotificationVisible}
            onClose={() => this.setState({ sendNotificationVisible: false })}
            onSend={async (subject, body, bodyFull) => {
              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });

              var studentiCorso = await getStudenti(username, token);
              studentiCorso = studentiCorso.filter((s) =>
                s.corsi
                  .split(";")
                  .filter(Boolean)
                  .includes(this.state.notificationCorso.toString())
              );

              await addNotification(
                username,
                token,
                "CORSO",
                this.state.notificationCorso,
                subject,
                body,
                bodyFull,
                0
              );
              studentiCorso.forEach(async (studente) => {
                await addNotification(
                  username,
                  token,
                  "STUDENTE",
                  studente.id,
                  subject,
                  body,
                  bodyFull,
                  1
                );
              });

              this.setState({ waitDialogVisible: false });
              this.setState({ sendNotificationVisible: false });
            }}
          />

          <SelectPdfDatesWidget
            show={this.state.selectPdfDatesVisible}
            key={Math.random()}
            onOkClicked={(dateFrom, dateTo) => {
              const cookies = new Cookies();
              cookies.set("currentCorso", this.state.pdfElem, { path: "/" });
              cookies.set("dateFrom", dateFrom, { path: "/" });
              cookies.set("dateTo", dateTo, { path: "/" });
              window.location.href = "#/app/pdfCorsoPage";
            }}
          />

          <WaitDialog
            show={this.state.waitDialogVisible}
            key={Math.random()}
            index={this.state.index}
          />
        </LoadingOverlay>
        {this.state.costoCorso !== null && (
          <CostoCorsoDialog
            corso={this.state.costoCorso}
            nome={this.state.nomeCorsoCosto}
            onClose={() =>
              this.setState({ costoCorso: null, nomeCorsoCosto: null })
            }
          />
        )}
      </div>
    );
  }
}
